// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "../tables/LatestJobs.css";

// const AllResults = () => {
//   const [data, setData] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs`)
//       .then((res) => res.json())
//       .then((jobs) => {
//         const filtered = jobs.filter(
//           (job) => job.result && job.result.length > 0
//         );

//         const sorted = filtered.sort((a, b) => {
//           const aLatest = Math.max(
//             ...a.result.map((r) => new Date(r.updatedAt).getTime() || 0)
//           );
//           const bLatest = Math.max(
//             ...b.result.map((r) => new Date(r.updatedAt).getTime() || 0)
//           );
//           return bLatest - aLatest;
//         });

//         setData(sorted);
//       })
//       .catch((err) => console.error("Failed to fetch results:", err));
//   }, []);

//   return (
//     <div className="table-card" style={{ maxWidth: "900px", margin: "2rem auto" }}>
//       <h3 className="table-title">All Results</h3>
//       <table className="styled-table">
//         <thead>
//           <tr>
//             <th>Exam</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((item, idx) => (
//             <tr key={idx}>
//               <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <span style={{ color: "#000", fontWeight: "bold", fontSize: "20px", lineHeight: "1", marginRight: "8px" }}>•</span>
//                 <a
//                   href={`/job/${item.slug}`}
//                   className="job-link"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(`/job/${item.slug}`);
//                   }}
//                 >
//                   {item.JobTitle}
//                 </a>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default AllResults;


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../tables/LatestJobs.css";

const AllResults = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
    fetch(`${API_URL}/jobs/results`)
      .then((res) => res.json())
      .then((jobs) => {
        console.log("Fetched All Results:", jobs);

        // Sort based on latest updatedAt in result array
        const sorted = jobs.sort((a, b) => {
          const aLatest = Math.max(
            ...a.result.map((r) => new Date(r.updatedAt || 0).getTime())
          );
          const bLatest = Math.max(
            ...b.result.map((r) => new Date(r.updatedAt || 0).getTime())
          );
          return bLatest - aLatest;
        });

        setData(sorted);
      })
      .catch((err) => console.error("Failed to fetch results:", err));
  }, []);

  return (
    <div
      className="table-card"
      style={{ maxWidth: "900px", margin: "2rem auto" }}
    >
      <h3 className="table-title">All Results</h3>
      <table className="styled-table">
        <thead>
          <tr>
            <th>Exam</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => (
            <tr key={idx}>
              <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span
                  style={{
                    color: "#000",
                    fontWeight: "bold",
                    fontSize: "20px",
                    lineHeight: "1",
                    marginRight: "8px",
                  }}
                >
                  •
                </span>
                <a
                  href={`/job/${item.slug}`}
                  className="job-link"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/job/${item.slug}`);
                  }}
                >
                  {item.JobTitle}
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AllResults;
